var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"add-user-table"},[_c('v-row',[_c('v-col',{attrs:{"cols":"23"}},[_c('data-table-users',{attrs:{"data":_vm.users,"showEdit":true},on:{"edit":_vm.editUser,"delete":_vm.deleteUser}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }